<template>
  <v-row dense>
    <v-col>
      <v-row>
        <v-col>
          <v-text-field
            label="Busca"
            v-model="filter"
            outlined
            dense
            hide-details
            clearable
            append-icon="eva-search-outline"
            background-color="white"
          />
        </v-col>

        <v-spacer />

        <v-col cols="auto">
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="light-blue"
                dark
                v-bind="attrs"
                v-on="on"
                @click:outside="close"
              >
                Novo protocolo
              </v-btn>
            </template>

            <v-card>
              <v-card-title>
                <span class="headline">Novo protocolo</span>
              </v-card-title>

              <v-card-text>
                <v-container fluid>
                  <v-row dense>
                    <v-col>
                      <v-text-field
                        outlined
                        dense
                        hide-details
                        v-model="template.name"
                        label="Nome"
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">
                  Cancelar
                </v-btn>

                <v-btn color="blue darken-1" text @click="save"> Salvar </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>

      <v-row dense v-for="template in templatesList" :key="template.id">
        <v-col>
          <ClinicTherapyListItem
            :template="template"
            :medicines="medicines"
            :refreshList="refreshList"
          />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import ClinicTherapyListItem from "./item/index.vue";

export default {
  name: "ClinicTherapyList",
  components: {
    ClinicTherapyListItem,
  },
  data() {
    return {
      dialog: null,
      template: {},
      filter: "",
    };
  },
  apollo: {
    templates: {
      query: require("@/graphql/template/templates.gql"),
      pollInterval: 20000,
    },
    medicines: {
      query: require("@/graphql/medicine/medicines.gql"),
      variables: {
        disabled: false,
      },
      update({ medicines }) {
        return medicines.collection;
      },
    },
  },
  computed: {
    templatesList() {
      let templatesList = this.lodash.filter(
        this.templates,
        function (template) {
          let filteredItems = this.lodash.filter(template.items, {
            templateType: "attendance_therapy",
          });

          return !this.lodash.isEmpty(filteredItems);
        }.bind(this)
      );

      templatesList = templatesList.concat(
        this.lodash.filter(this.templates, (template) => {
          return template.items.length === 0;
        })
      );

      if (this.filter) {
        templatesList = this.lodash.filter(
          templatesList,
          function (e) {
            return e.name
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .includes(
                this.filter
                  .toLowerCase()
                  .normalize("NFD")
                  .replace(/[\u0300-\u036f]/g, "")
              );
          }.bind(this)
        );
      }

      return templatesList;
    },
  },
  methods: {
    close() {
      this.dialog = false;
      this.template = {};
    },
    save() {
      this.apolloMutate({
        mutation: require("@/graphql/template/save_template.gql"),
        variables: {
          templateId: "",
          name: this.template.name,
        },
      }).then(() => {
        this.refreshList();

        this.$store.dispatch("createNotification", {
          message: "Cadastro salvo com sucesso.",
          type: "success",
        });
      });

      this.close();
    },
    refreshList() {
      this.$apollo.queries.templates.refetch();
    },
  },
};
</script>

<style lang="scss" scoped></style>
